import { memo } from 'react';
import PropTypes from 'prop-types';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import { profileSelectors } from 'features/profile';
import { sessionsSelectors } from 'features/sessions';
import useCustomSelector from 'hooks/useCustomSelector';

const ProtectedManagerRoute = ({ children }) => {
  const profileManager = useCustomSelector(profileSelectors.getProfileData);
  const localSession = useCustomSelector(sessionsSelectors.getManagerSession);

  if (!localSession.accessToken || !profileManager.id) return null;
  return children;
};

ProtectedManagerRoute.propTypes = {
  children: PropTypes.node.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ProtectedManagerRoute {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);